<template>
    <div>
      <Header></Header>
      <Alert v-if="message.length > 0" @on-close="test" type="error" closable style="margin:0 auto;width: 70%;">{{message}}</Alert>
      <div>
        <Titleline :title="title"></Titleline>
      </div>
      <Form :model="formItem" :label-width="80">
        <FormItem label="关键字" style="text-align:left">
            <Input style="width: 80%" v-model="formItem.keywords" type="textarea" placeholder="输入关键字，每行一个关键词，可以同时输入多个词"/>
            <p v-if="kwtip.length > 0"><span style="color:blue">{{kwtip}}</span></p>
            <p><span style="color:blue">关键字批量采集，</span><span style="color:red">每行一个关键词。</span>
              <span>也支持关键词用英文逗号分隔</span></p>
        </FormItem>
        <FormItem label="APP名称" style="text-align: left;">
          <RadioGroup v-model="formItem.appname">
              <Radio label="抖音"></Radio>
              <Radio label="今日头条"></Radio>
          </RadioGroup>
        </FormItem>
        <FormItem label="开始日期">
            <Row style="text-align: left;">
                <Col>
                  <DatePicker type="date" placeholder="选择时间" v-model="formItem.begin_at"></DatePicker>
                  时间最早为2019-01-01
                </Col>
            </Row>
        </FormItem>
        <FormItem label="结束日期">
            <Row style="text-align: left;">
                <Col span="11">
                  <DatePicker type="date" placeholder="选择时间" v-model="formItem.end_at"></DatePicker>
                  时间最晚为昨天
                </Col>
            </Row>
        </FormItem>
        <FormItem label="地区类型" style="text-align: left;">
          <RadioGroup v-model="formItem.regiontype">
              <Radio label="地区分开查询"></Radio>
              <Radio label="地区合并查询"></Radio>
          </RadioGroup>
        </FormItem>
        <FormItem label="选择地区" style="text-align: left;">
            <Checkbox v-model="formItem.all">全国总数</Checkbox>
            <span style="color:blue;">{{regiontip}}</span>
            <CheckboxGroup v-model="formItem.selRegion">
              <p>省份：
                <i-switch size="large" @on-change="handleShengCheckAll">
                <span slot="open">关闭</span>
                <span slot="close">全选</span></i-switch></p>
              <Checkbox v-for="(val, key) in regions" :label="val" :key="key">{{val}}</Checkbox>
              <p>城市：<i-switch v-model="city_show" size="large">
                <span slot="open">显示</span>
                <span slot="close">隐藏</span>
            </i-switch></p>
              <List border v-show="city_show">
                <ListItem v-for="(cityarray, pro) in pro_city"  :key="pro"><i-switch @on-change="handleShiCheckAll(pro)">
                <span slot="open">关</span>
                <span slot="close">全</span></i-switch>&nbsp;{{ pro }}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  <Checkbox v-for="(val, key) in cityarray" :label="val" :key="key">{{val}}</Checkbox>
                </ListItem>
              </List>
              <!-- <p>城市：</p>
              <Checkbox v-for="(val, key) in citys" :label="key" :key="key">{{val}}</Checkbox> -->
            </CheckboxGroup>
        </FormItem>
        <input type="hidden" id="params" name="" v-model="allparams">
        <input type="hidden" id="msg" name="" v-model="nmsg">
        <input type="hidden" id="taskinfo" name="" v-model="taskinfo">
        <input type="hidden" id="downlist" name="" v-model="downlistjson">
        <input type="hidden" id="kzversionid" name="" v-model="kzversion">
        <input type="hidden" id="iniscontinue" name="" v-model="iniscontinueV">
        <input type="hidden" id="vipinfo" name="" v-model="vipinfo">
        <input type="hidden" id="tasklittle" name="" v-model="tasklittle">

        <FormItem style="text-align:left;">
            <Button id="begin" type="primary" @click="test">开始采集</Button>
            <Button style="margin-left: 8px" @click="cancel">取消</Button>
            <Button style="margin-left: 8px" id="contok" @click="contok" :disabled="is_disable">继续采集</Button>
            <!-- <Button style="margin-left: 8px" id="openfolder">打开下载目录</Button> -->
            <span style="margin-left: 100px;font-size:20px" v-show="nokz">请先安装浏览器扩展<a class="sec" href="/introne#kz">（点击这里下载）</a>，所有操作都在一个浏览器执行</span>
        </FormItem>
        <p class="wxts-p">温馨提示：在开始采集数据之前，请先在同一个浏览器的其他页面提前登录一下抖音指数账号，采集过程中会使用该账号进行采集，地址：<a style="color:black" target="_blank" href="https://creator.douyin.com/creator-micro/creator-count">https://creator.douyin.com/creator-micro/creator-count</a></p>
      </Form>
      <div v-show="tasklist.length > 0 || mallcount > 0">
        <Titleline title="采集结果"></Titleline>
          <div  style="text-align:left;margin:20px 50px;width:80%">
            <p>说明：在采集的过程中，<span style="color:red">不要刷新页面</span>，否则采集过程会<span style="color:red">中断</span>。切记！</p>
            <!-- <p>风险提示：采集过程任务在<span style="color:red">几万次请求</span>的情况下，会有帐号被<span style="color:red">百度指数官方限制查询</span>的情况，可以考虑预先准备几个百度指数账号，更换使用！限制查询一般6～7天后会自动解除</p> -->
            <br>
            <Alert v-if="message.length > 0" @on-close="test" type="error" closable>{{message}}</Alert>
            <p>采集进度<img v-if="running && is_disable" style="height: 21px;opacity: 0.7;vertical-align: bottom;" src="../../static/images/exec.gif"></p>
            <Progress :percent="process" :stroke-width="20" status="active" text-inside />
          </div>
          <CheckboxGroup v-if="showlist" v-model="downlist" style="text-align:left;margin:0 50px;">
            <Checkbox v-for="(val, key) in tasklist" :label="val.word +'_'+ val.code+'_'+ val.region" :key="key" :disabled="val.count != val.finished">{{val.word}}_{{val.region}}.xlsx
              <span v-if="val.shoulu && val.count == val.finished && !val.autodown" style="color:blue;">(已完成)</span>
              <span v-else-if="val.shoulu && val.autodown" style="color:#3ebe70;">(已保存)</span>
              <span v-else-if="val.shoulu" style="color:gray;">(采集中)</span>
              <span v-else-if="val.shoulu == false" style="color:#CD950C;">(未收录)</span>
            </Checkbox>
            <div style="margin: 30px 0; display: none;">
              <Button id="download" type="primary">下载选择的文件</Button>
            </div>
          </CheckboxGroup>
          <div v-else style="text-align:left;margin:20px 50px;width:80%">
            <p>由于采集内容太多，只显示需要采集的次数数据</p>
            <p>总采集数：{{mallcount}}</p>
            <p>已采集数：{{mallfinished}}</p>
          </div>
          <div style="margin: 80px 0">
          </div>
      </div>
    </div>
</template>
<script>
import Titleline from './titleline'
import Header from './header'
import helper from '../lib/helper'

export default {
  components: {
    Titleline,
    Header
  },
  watch: {
    'iniscontinueV': function (val, oldVal) {
      console.log('继续按钮')
      if (val.length === 0) {
        this.is_disable = true
      } else {
        this.is_disable = false
      }
    },
    '$store.state.vipinfo': function (val, oldVal) {
      this.gentip(this.$store.state.vipinfo)
    },
    // 用于传参给扩展。
    'formItem.keywords': function (val, oldVal) {
      // console.log('keywords is change')
      this.checkkw()
      this.allparams = this.formJson()
    },
    'formItem.appname': function (val, oldVal) {
      this.allparams = this.formJson()
    },
    'formItem.regiontype': function (val, oldVal) {
      this.allparams = this.formJson()
    },
    'formItem.begin_at': function (val, oldVal) {
      this.allparams = this.formJson()
    },
    'formItem.end_at': function (val, oldVal) {
      this.allparams = this.formJson()
    },
    'formItem.selRegion': function (val, oldVal) {
      this.checkregion()
      this.allparams = this.formJson()
    },
    'formItem.all': function (val, oldVal) {
      this.checkregion()
      this.allparams = this.formJson()
    },
    'downlist': function (val, oldVal) {
      this.downlistjson = JSON.stringify(this.downlist)
    },
    'nmsg': function (val, oldVal) {
      if (val.length === 0) {
        return
      }
      // this.$Message.error({
      //   content: val,
      //   duration: 10
      // })
      this.message = val
      this.nmsg = ''
    },
    'tasklittle': function (val, oldVal) {
      this.taskts = new Date().getTime()
      if (val.length === 0) {
        return
      }
      var t = JSON.parse(val)
      this.running = true
      this.showlist = false
      this.mallcount = t.allcount
      this.mallfinished = t.allfinished
      if (this.mallcount === 0) {
        // 避免0位除数
        this.process = 100
      } else {
        this.process = Math.floor(this.mallfinished / this.mallcount * 100)
      }
      if (this.process >= 100) {
        this.running = false
      }
    },
    'taskinfo': function (val, oldVal) {
      this.cleardata()
      this.taskts = new Date().getTime()
      if (val.length === 0) {
        return
      }
      var t = JSON.parse(val)
      // console.log('taskinfo values: ', t)
      this.running = true
      // 计算总进度度
      var allcount = 0
      var allfinished = 0
      var res = []
      this.downlist.length = 0
      for (let idx in t) {
        var obj = t[idx]
        var v = idx.split('_')
        var word = v[0]
        var c = v.slice(1)
        var code = c.join('_')
        // var region = this.citys[code]
        obj['word'] = word
        obj['region'] = code
        obj['code'] = code
        allcount += obj['count']
        allfinished += obj['finished']
        if (obj.hasOwnProperty('shoulu')) {
        } else {
          obj['shoulu'] = true
        }
        res.push(obj)
        if (obj['count'] === obj['finished'] && obj['count'] > 0 && !obj['autodown']) {
          var label = obj['word'] + '_' + obj['code'] + '_' + obj['region']
          this.downlist.push(label)
        }
      }
      this.tasklist = res
      this.mallcount = allcount
      this.mallfinished = allfinished
      if (allcount === 0) {
        // 避免0位除数
        this.process = 100
      } else {
        this.process = Math.floor(allfinished / allcount * 100)
        if (this.process > 100) {
          this.process = 100
        }
      }
      if (this.process >= 100) {
        this.running = false
      }
    }
  },
  data () {
    return {
      title: '抖音指数关键词指数',
      message: '',
      mallfinished: 0,
      mallcount: 0,
      showlist: true,
      tasklittle: '',
      formItem: {
        keywords: '',
        begin_at: '',
        end_at: '',
        all: true,
        appname: '抖音',
        regiontype: '地区分开查询',
        selRegion: []
      },
      vipinfo: '',
      kwtip: '',
      kwnum: 5,
      regiontip: '',
      regionnum: 1,
      subCheck: {},
      nmsg: '',
      is_disable: true,
      iniscontinueV: '',
      taskts: 0,
      taskinfo: '',
      // 展示使用
      tasklist: [
      // {
      //   code: '0',
      //   count: 1,
      //   finished: 1,
      //   region: '全国',
      //   word: '手套'
      // }, {
      //   code: '0',
      //   count: 1,
      //   finished: 0,
      //   region: '全国',
      //   word: '帽子'
      // }
      ],
      process: 0,
      running: false, // 任务运行中点击开始按钮
      downlist: [],
      downlistjson: '',
      nokz: false,
      kzversion: '',
      allparams: '',
      city_show: false,
      regions: {
        901: '山东',
        902: '贵州',
        903: '江西',
        904: '重庆',
        905: '内蒙古',
        906: '湖北',
        907: '辽宁',
        908: '湖南',
        909: '福建',
        910: '上海',
        911: '北京',
        912: '广西',
        913: '广东',
        914: '四川',
        915: '云南',
        916: '江苏',
        917: '浙江',
        918: '青海',
        919: '宁夏',
        920: '河北',
        921: '黑龙江',
        922: '吉林',
        923: '天津',
        924: '陕西',
        925: '甘肃',
        926: '新疆',
        927: '河南',
        928: '安徽',
        929: '山西',
        930: '海南',
        931: '台湾',
        932: '西藏',
        933: '香港',
        934: '澳门'
      },
      pro_city: {
        '特别市': {
          514: '北京',
          57: '上海',
          164: '天津',
          11: '重庆',
          663: '香港',
          664: '澳门'
        },
        '安徽': {
          189: '合肥',
          173: '铜陵',
          174: '黄山',
          175: '池州',
          176: '宣城',
          178: '淮南',
          179: '宿州',
          181: '六安',
          182: '滁州',
          183: '淮北',
          184: '阜阳',
          185: '马鞍山',
          186: '安庆',
          187: '蚌埠',
          188: '芜湖',
          391: '亳州'
        },
        '福建': {
          50: '福州',
          51: '莆田',
          52: '三明',
          53: '龙岩',
          54: '厦门',
          55: '泉州',
          56: '漳州',
          87: '宁德',
          253: '南平'
        },
        '广东': {
          95: '广州',
          94: '深圳',
          133: '东莞',
          195: '云浮',
          196: '佛山',
          197: '湛江',
          198: '江门',
          199: '惠州',
          200: '珠海',
          201: '韶关',
          202: '阳江',
          203: '茂名',
          204: '潮州',
          205: '揭阳',
          207: '中山',
          208: '清远',
          209: '肇庆',
          210: '河源',
          211: '梅州',
          212: '汕头',
          213: '汕尾'
        },
        '广西': {
          90: '南宁',
          89: '柳州',
          91: '桂林',
          92: '贺州',
          93: '贵港',
          118: '玉林',
          119: '河池',
          128: '北海',
          129: '钦州',
          130: '防城港',
          131: '百色',
          132: '梧州',
          506: '来宾',
          665: '崇左'
        },
        '甘肃': {
          166: '兰州',
          281: '庆阳',
          282: '定西',
          283: '武威',
          284: '酒泉',
          285: '张掖',
          286: '嘉峪关',
          307: '平凉',
          308: '天水',
          309: '白银',
          343: '金昌',
          344: '陇南',
          346: '临夏',
          673: '甘南'
        },
        '贵州': {
          2: '贵阳',
          3: '黔南',
          4: '六盘水',
          59: '遵义',
          61: '黔东南',
          422: '铜仁',
          424: '安顺',
          426: '毕节',
          588: '黔西南'
        },
        '河北': {
          141: '石家庄',
          143: '衡水',
          144: '张家口',
          145: '承德',
          146: '秦皇岛',
          147: '廊坊',
          148: '沧州',
          259: '保定',
          261: '唐山',
          292: '邯郸',
          293: '邢台'
        },
        '黑龙江': {
          152: '哈尔滨',
          153: '大庆',
          295: '伊春',
          297: '大兴安岭',
          300: '黑河',
          301: '鹤岗',
          302: '七台河',
          319: '齐齐哈尔',
          320: '佳木斯',
          322: '牡丹江',
          323: '鸡西',
          324: '绥化',
          359: '双鸭山'
        },
        '河南': {
          168: '郑州',
          262: '南阳',
          263: '新乡',
          264: '开封',
          265: '焦作',
          266: '平顶山',
          268: '许昌',
          370: '安阳',
          371: '驻马店',
          373: '信阳',
          374: '鹤壁',
          375: '周口',
          376: '商丘',
          378: '洛阳',
          379: '漯河',
          380: '濮阳',
          381: '三门峡',
          667: '济源'
        },
        '湖南': {
          43: '长沙',
          44: '岳阳',
          45: '衡阳',
          46: '株洲',
          47: '湘潭',
          48: '益阳',
          49: '郴州',
          65: '湘西',
          66: '娄底',
          67: '怀化',
          68: '常德',
          226: '张家界',
          269: '永州',
          405: '邵阳'
        },
        '湖北': {
          28: '武汉',
          30: '黄石',
          31: '荆州',
          32: '襄阳',
          33: '黄冈',
          34: '荆门',
          35: '宜昌',
          36: '十堰',
          37: '随州',
          38: '恩施',
          39: '鄂州',
          40: '咸宁',
          41: '孝感',
          42: '仙桃',
          73: '天门',
          74: '潜江',
          687: '神农架'
        },
        '海南': {
          239: '海口',
          241: '万宁',
          242: '琼海',
          243: '三亚',
          244: '儋州',
          456: '东方',
          582: '五指山',
          670: '文昌',
          674: '陵水',
          675: '澄迈',
          679: '乐东',
          680: '临高',
          681: '定安',
          683: '昌江',
          684: '屯昌',
          686: '保亭',
          689: '白沙',
          690: '琼中',
          691: '三沙'
        },
        '吉林': {
          154: '长春',
          155: '四平',
          191: '辽源',
          194: '松原',
          407: '通化',
          408: '白山',
          410: '白城',
          525: '延边'
        },
        '江苏': {
          125: '南京',
          126: '苏州',
          127: '无锡',
          156: '连云港',
          157: '淮安',
          158: '扬州',
          159: '泰州',
          160: '盐城',
          161: '徐州',
          162: '常州',
          163: '南通',
          169: '镇江',
          172: '宿迁'
        },
        '江西': {
          5: '南昌',
          6: '九江',
          7: '鹰潭',
          8: '抚州',
          9: '上饶',
          10: '赣州',
          115: '吉安',
          136: '萍乡',
          137: '景德镇',
          246: '新余',
          256: '宜春'
        },
        '辽宁': {
          29: '大连',
          150: '沈阳',
          151: '盘锦',
          215: '鞍山',
          216: '朝阳',
          217: '锦州',
          218: '铁岭',
          219: '丹东',
          220: '本溪',
          221: '营口',
          222: '抚顺',
          223: '阜新',
          224: '辽阳',
          225: '葫芦岛'
        },
        '内蒙古': {
          13: '包头',
          14: '鄂尔多斯',
          15: '巴彦淖尔',
          16: '乌海',
          17: '阿拉善',
          19: '锡林郭勒',
          20: '呼和浩特',
          21: '赤峰',
          22: '通辽',
          25: '呼伦贝尔',
          331: '乌兰察布',
          333: '兴安'
        },
        '宁夏': {
          140: '银川',
          395: '吴忠',
          396: '固原',
          472: '石嘴山',
          480: '中卫'
        },
        '青海': {
          139: '西宁',
          608: '海西',
          652: '海东',
          659: '玉树',
          676: '海南州',
          682: '海北',
          685: '黄南',
          688: '果洛'
        },
        '四川': {
          96: '宜宾',
          97: '成都',
          98: '绵阳',
          99: '广元',
          100: '遂宁',
          101: '巴中',
          102: '内江',
          103: '泸州',
          104: '南充',
          106: '德阳',
          107: '乐山',
          108: '广安',
          109: '资阳',
          111: '自贡',
          112: '攀枝花',
          113: '达州',
          114: '雅安',
          291: '眉山',
          417: '甘孜',
          457: '阿坝',
          479: '凉山'
        },
        '山东': {
          1: '济南',
          76: '滨州',
          77: '青岛',
          78: '烟台',
          79: '临沂',
          80: '潍坊',
          81: '淄博',
          82: '东营',
          83: '聊城',
          84: '菏泽',
          85: '枣庄',
          86: '德州',
          88: '威海',
          352: '济宁',
          353: '泰安',
          // 356: '莱芜',
          366: '日照'
        },
        '山西': {
          227: '大同',
          228: '长治',
          229: '忻州',
          230: '晋中',
          231: '太原',
          232: '临汾',
          233: '运城',
          234: '晋城',
          235: '朔州',
          236: '阳泉',
          237: '吕梁'
        },
        '陕西': {
          165: '西安',
          271: '铜川',
          272: '安康',
          273: '宝鸡',
          274: '商洛',
          275: '渭南',
          276: '汉中',
          277: '咸阳',
          278: '榆林',
          401: '延安'
        },
        '西藏': {
          466: '拉萨',
          516: '日喀则',
          655: '那曲',
          656: '林芝',
          677: '山南',
          678: '昌都',
          691: '阿里'
        },
        '新疆': {
          280: '石河子',
          310: '吐鲁番',
          311: '昌吉',
          312: '哈密',
          315: '阿克苏',
          317: '克拉玛依',
          318: '博尔塔拉',
          383: '阿勒泰',
          384: '喀什',
          386: '和田',
          467: '乌鲁木齐',
          499: '巴音郭楞',
          520: '伊犁',
          563: '塔城',
          653: '克孜勒苏',
          661: '五家渠',
          692: '阿拉尔',
          694: '北屯',
          693: '图木舒克',
          695: '双河',
          698: '昆玉',
          699: '胡杨河',
          700: '铁门关',
          701: '可克达拉'
        },
        '云南': {
          117: '昆明',
          123: '玉溪',
          124: '楚雄',
          334: '大理',
          335: '昭通',
          337: '红河',
          339: '曲靖',
          342: '丽江',
          350: '临沧',
          437: '文山',
          438: '保山',
          // 662: '思茅',
          666: '普洱',
          668: '西双版纳',
          669: '德宏',
          671: '怒江',
          672: '迪庆'
        },
        '浙江': {
          134: '丽水',
          135: '金华',
          138: '杭州',
          149: '温州',
          287: '台州',
          288: '衢州',
          289: '宁波',
          303: '绍兴',
          304: '嘉兴',
          305: '湖州',
          306: '舟山'
        }
      },
      citys: {
        0: '全国',
        901: '山东',
        902: '贵州',
        903: '江西',
        904: '重庆',
        905: '内蒙古',
        906: '湖北',
        907: '辽宁',
        908: '湖南',
        909: '福建',
        910: '上海',
        911: '北京',
        912: '广西',
        913: '广东',
        914: '四川',
        915: '云南',
        916: '江苏',
        917: '浙江',
        918: '青海',
        919: '宁夏',
        920: '河北',
        921: '黑龙江',
        922: '吉林',
        923: '天津',
        924: '陕西',
        925: '甘肃',
        926: '新疆',
        927: '河南',
        928: '安徽',
        929: '山西',
        930: '海南',
        931: '台湾',
        932: '西藏',
        933: '香港',
        934: '澳门',
        1: '济南',
        2: '贵阳',
        3: '黔南',
        4: '六盘水',
        5: '南昌',
        6: '九江',
        7: '鹰潭',
        8: '抚州',
        9: '上饶',
        10: '赣州',
        11: '重庆',
        13: '包头',
        14: '鄂尔多斯',
        15: '巴彦淖尔',
        16: '乌海',
        17: '阿拉善盟',
        19: '锡林郭勒盟',
        20: '呼和浩特',
        21: '赤峰',
        22: '通辽',
        25: '呼伦贝尔',
        28: '武汉',
        29: '大连',
        30: '黄石',
        31: '荆州',
        32: '襄阳',
        33: '黄冈',
        34: '荆门',
        35: '宜昌',
        36: '十堰',
        37: '随州',
        38: '恩施',
        39: '鄂州',
        40: '咸宁',
        41: '孝感',
        42: '仙桃',
        43: '长沙',
        44: '岳阳',
        45: '衡阳',
        46: '株洲',
        47: '湘潭',
        48: '益阳',
        49: '郴州',
        50: '福州',
        51: '莆田',
        52: '三明',
        53: '龙岩',
        54: '厦门',
        55: '泉州',
        56: '漳州',
        57: '上海',
        59: '遵义',
        61: '黔东南',
        65: '湘西',
        66: '娄底',
        67: '怀化',
        68: '常德',
        73: '天门',
        74: '潜江',
        76: '滨州',
        77: '青岛',
        78: '烟台',
        79: '临沂',
        80: '潍坊',
        81: '淄博',
        82: '东营',
        83: '聊城',
        84: '菏泽',
        85: '枣庄',
        86: '德州',
        87: '宁德',
        88: '威海',
        89: '柳州',
        90: '南宁',
        91: '桂林',
        92: '贺州',
        93: '贵港',
        94: '深圳',
        95: '广州',
        96: '宜宾',
        97: '成都',
        98: '绵阳',
        99: '广元',
        100: '遂宁',
        101: '巴中',
        102: '内江',
        103: '泸州',
        104: '南充',
        106: '德阳',
        107: '乐山',
        108: '广安',
        109: '资阳',
        111: '自贡',
        112: '攀枝花',
        113: '达州',
        114: '雅安',
        115: '吉安',
        117: '昆明',
        118: '玉林',
        119: '河池',
        123: '玉溪',
        124: '楚雄',
        125: '南京',
        126: '苏州',
        127: '无锡',
        128: '北海',
        129: '钦州',
        130: '防城港',
        131: '百色',
        132: '梧州',
        133: '东莞',
        134: '丽水',
        135: '金华',
        136: '萍乡',
        137: '景德镇',
        138: '杭州',
        139: '西宁',
        140: '银川',
        141: '石家庄',
        143: '衡水',
        144: '张家口',
        145: '承德',
        146: '秦皇岛',
        147: '廊坊',
        148: '沧州',
        149: '温州',
        150: '沈阳',
        151: '盘锦',
        152: '哈尔滨',
        153: '大庆',
        154: '长春',
        155: '四平',
        156: '连云港',
        157: '淮安',
        158: '扬州',
        159: '泰州',
        160: '盐城',
        161: '徐州',
        162: '常州',
        163: '南通',
        164: '天津',
        165: '西安',
        166: '兰州',
        168: '郑州',
        169: '镇江',
        172: '宿迁',
        173: '铜陵',
        174: '黄山',
        175: '池州',
        176: '宣城',
        177: '巢湖',
        178: '淮南',
        179: '宿州',
        181: '六安',
        182: '滁州',
        183: '淮北',
        184: '阜阳',
        185: '马鞍山',
        186: '安庆',
        187: '蚌埠',
        188: '芜湖',
        189: '合肥',
        191: '辽源',
        194: '松原',
        195: '云浮',
        196: '佛山',
        197: '湛江',
        198: '江门',
        199: '惠州',
        200: '珠海',
        201: '韶关',
        202: '阳江',
        203: '茂名',
        204: '潮州',
        205: '揭阳',
        207: '中山',
        208: '清远',
        209: '肇庆',
        210: '河源',
        211: '梅州',
        212: '汕头',
        213: '汕尾',
        215: '鞍山',
        216: '朝阳',
        217: '锦州',
        218: '铁岭',
        219: '丹东',
        220: '本溪',
        221: '营口',
        222: '抚顺',
        223: '阜新',
        224: '辽阳',
        225: '葫芦岛',
        226: '张家界',
        227: '大同',
        228: '长治',
        229: '忻州',
        230: '晋中',
        231: '太原',
        232: '临汾',
        233: '运城',
        234: '晋城',
        235: '朔州',
        236: '阳泉',
        237: '吕梁',
        239: '海口',
        241: '万宁',
        242: '琼海',
        243: '三亚',
        244: '儋州',
        246: '新余',
        253: '南平',
        256: '宜春',
        259: '保定',
        261: '唐山',
        262: '南阳',
        263: '新乡',
        264: '开封',
        265: '焦作',
        266: '平顶山',
        268: '许昌',
        269: '永州',
        270: '吉林',
        271: '铜川',
        272: '安康',
        273: '宝鸡',
        274: '商洛',
        275: '渭南',
        276: '汉中',
        277: '咸阳',
        278: '榆林',
        280: '石河子',
        281: '庆阳',
        282: '定西',
        283: '武威',
        284: '酒泉',
        285: '张掖',
        286: '嘉峪关',
        287: '台州',
        288: '衢州',
        289: '宁波',
        291: '眉山',
        292: '邯郸',
        293: '邢台',
        295: '伊春',
        297: '大兴安岭',
        300: '黑河',
        301: '鹤岗',
        302: '七台河',
        303: '绍兴',
        304: '嘉兴',
        305: '湖州',
        306: '舟山',
        307: '平凉',
        308: '天水',
        309: '白银',
        310: '吐鲁番',
        311: '昌吉',
        312: '哈密',
        315: '阿克苏',
        317: '克拉玛依',
        318: '博尔塔拉',
        319: '齐齐哈尔',
        320: '佳木斯',
        322: '牡丹江',
        323: '鸡西',
        324: '绥化',
        331: '乌兰察布',
        333: '兴安盟',
        334: '大理',
        335: '昭通',
        337: '红河',
        339: '曲靖',
        342: '丽江',
        343: '金昌',
        344: '陇南',
        346: '临夏',
        350: '临沧',
        352: '济宁',
        353: '泰安',
        356: '莱芜',
        359: '双鸭山',
        366: '日照',
        370: '安阳',
        371: '驻马店',
        373: '信阳',
        374: '鹤壁',
        375: '周口',
        376: '商丘',
        378: '洛阳',
        379: '漯河',
        380: '濮阳',
        381: '三门峡',
        383: '阿勒泰',
        384: '喀什',
        386: '和田',
        391: '亳州',
        395: '吴忠',
        396: '固原',
        401: '延安',
        405: '邵阳',
        407: '通化',
        408: '白山',
        410: '白城',
        417: '甘孜',
        422: '铜仁',
        424: '安顺',
        426: '毕节',
        437: '文山',
        438: '保山',
        456: '东方',
        457: '阿坝',
        466: '拉萨',
        467: '乌鲁木齐',
        472: '石嘴山',
        479: '凉山',
        480: '中卫',
        499: '巴音郭楞',
        506: '来宾',
        514: '北京',
        516: '日喀则',
        520: '伊犁',
        525: '延边',
        563: '塔城',
        582: '五指山',
        588: '黔西南',
        608: '海西',
        652: '海东',
        653: '克孜勒苏柯尔克孜',
        654: '天门仙桃',
        655: '那曲',
        656: '林芝',
        657: 'None',
        658: '防城',
        659: '玉树',
        // 660: '伊犁哈萨克',
        661: '五家渠',
        662: '思茅',
        663: '香港',
        664: '澳门',
        665: '崇左',
        666: '普洱',
        667: '济源',
        668: '西双版纳',
        669: '德宏',
        670: '文昌',
        671: '怒江',
        672: '迪庆',
        673: '甘南',
        674: '陵水',
        675: '澄迈',
        676: '海南',
        677: '山南',
        678: '昌都',
        679: '乐东',
        680: '临高',
        681: '定安',
        682: '海北',
        683: '昌江',
        684: '屯昌',
        685: '黄南',
        686: '保亭',
        687: '神农架',
        688: '果洛',
        689: '白沙',
        690: '琼中',
        691: '阿里',
        692: '阿拉尔',
        693: '图木舒克'
      }
    }
  },
  computed: {
  },
  mounted: function () {
    console.log('params ', this.$route.query)
    if (this.$route.query && this.$route.query.id) {
      this.loaddetail(this.$route.query.id)
    }
    var that = this
    setTimeout(function () {
      if (that.kzversion.length === 0) {
        that.nokz = true
        console.log('no version ', that.kzversion)
      } else {
        that.nokz = false
        console.log('version ', that.kzversion)
      }
    }, 10000)
    setInterval(() => {
      this.timehandle()
    }, 5000)
    this.getVipInfo()
    this.gentip(this.$store.state.vipinfo)
  },
  methods: {
    formJson () {
      let t = this.formItem.keywords.replace(/\r\n/g, ',')
      let r = t.replace(/\n/g, ',')
      let f = {
        keyword: r,
        begin_at: this.formItem.begin_at,
        end_at: this.formItem.end_at,
        all: this.formItem.all,
        selRegion: this.formItem.selRegion,
        regiontype: this.formItem.regiontype,
        appname: this.formItem.appname
      }
      return JSON.stringify(f)
    },
    getVipInfo () {
      // 获取用户信息
      var that = this
      var url = this.$store.state.baseurl + '/mapi/user/getvip'
      this.axios.get(
        url,
        {
        }
      ).then(function (res) {
        if (res.data.code === 200) {
          // console.log('登录成功', res.data)
          var vinfo = res.data.data
          // console.log('vinfo', vinfo)
          that.$store.commit('SETVIP', vinfo)
        } else {
          console.log('getvip error', res)
        }
      }).catch((e) => {
        console.log('获取数据失败', e)
      })
    },
    checkkw () {
      // let t = this.formItem.keywords.replace(/\r\n/g, ',')
      // let r = t.replace(/\n/g, ',')
      // var ka = r.split(',')
      // if (ka.length > this.kwnum) {
      //   if (this.kwtip.length > 0) {
      //     this.$Message.error({
      //       content: this.kwtip + '，当前为' + ka.length + '个',
      //       duration: 5
      //     })
      //   }
      // }
    },
    checkregion () {
      var l = this.formItem.selRegion.length
      if (this.formItem.all) {
        l += 1
      }
      if (l > this.regionnum) {
        if (this.regiontip.length > 0) {
          this.$Message.error({
            content: this.regiontip + '，当前为' + l + '个',
            duration: 5
          })
        }
      }
    },
    gentip (val) {
      if (!val) {
        return
      }
      this.vipname = helper.getName(val)
      this.kwnum = helper.getKwNum(val)
      this.regionnum = helper.getRegionNum(val)
      var name = this.vipname
      if (name === '个人中心') {
        name = ''
      } else {
        name += '用户'
      }
      name = ''
      this.kwtip = name + '可以同时采集' + this.kwnum + '个关键字'
      if (this.regionnum < 500) {
        this.regiontip = name + '可以同时选择' + this.regionnum + '个地区'
      } else {
        this.regiontip = name + '不限制选择地区数量'
      }
      // 同时更新一下vipinfo到表达，供插件使用
      this.vipinfo = JSON.stringify(this.$store.state.vipinfo)
    },
    timehandle () {
      // 超时显示继续采集按钮
      var t = new Date().getTime()
      if (this.taskts <= 10000) {
        return
      }
      var tt = t - this.taskts
      if (tt >= 180000 && (this.process < 100) && (this.tasklist.length > 0 || this.mallcount > 0)) {
        if (this.iniscontinueV.length === 0) {
          this.iniscontinueV = '1'
        }
      }
    },
    contok () {
      this.test()
      this.iniscontinueV = ''
      this.message = ''
      console.log('点击继续了')
    },
    test () {
      this.message = ''
    },
    handleShengCheckAll (status) {
      if (status) {
        for (var t in this.regions) {
          if (this.formItem.selRegion.indexOf(this.regions[t]) === -1) {
            this.formItem.selRegion.push(this.regions[t])
          }
        }
      } else {
        for (let t in this.regions) {
          if (this.formItem.selRegion.indexOf(this.regions[t]) !== -1) {
            this.formItem.selRegion.splice(this.formItem.selRegion.indexOf(this.regions[t]), 1)
          }
        }
      }
    },
    handleShiCheckAll (param) {
      if (param in this.subCheck) {
        this.subCheck[param] = !this.subCheck[param]
      } else {
        this.subCheck[param] = true
      }
      if (this.subCheck[param]) {
        for (var t in this.pro_city[param]) {
          if (this.formItem.selRegion.indexOf(this.pro_city[param][t]) === -1) {
            this.formItem.selRegion.push(this.pro_city[param][t])
          }
        }
      } else {
        for (let t in this.pro_city[param]) {
          if (this.formItem.selRegion.indexOf(this.pro_city[param][t]) !== -1) {
            this.formItem.selRegion.splice(this.formItem.selRegion.indexOf(this.pro_city[param][t]), 1)
          }
        }
      }
    },
    cleardata () {
      this.downlist.length = 0
      this.downlistjson = ''
      this.tasklist.length = 0
      this.taskts = 0
      this.mallfinished = 0
      this.mallcount = 0
    },
    format (val) {
      return 'Progress: ' + this.process + '%'
    },
    loaddetail (id) {
      var url = '/mapi/itask/detail'
      console.log('url', url)
      var that = this
      const msg = this.$Message.loading({
        content: 'Loading...',
        duration: 0
      })

      this.axios.get(
        url,
        {
          params: {
            id: id
          }
        }
      ).then(function (res) {
        setTimeout(msg, 0)
        if (res.data.code === 200) {
          var param = res.data.data
          param.begin_at = new Date(parseInt(param.begin_at) * 1000)
          param.end_at = new Date(parseInt(param.end_at) * 1000)
          if (param.online) {
            param.online = true
          } else {
            param.online = false
          }
          param.type = param.type.toString()
          if (param.region_code.length > 0) {
            that.selRegion = param.region_code.split(',')
          }
          that.formItem = param
        } else {
          console.log('loaddetail error', res)
          // that.$Message.info(res.data.msg)
          that.message = res.data.msg
        }
      }).catch((e) => {
        setTimeout(msg, 0)
        console.log('获取数据失败', e)
        // that.$Message.info('获取数据失败')
        that.message = '获取数据失败'
      })
    },
    commit () {
      // 获取用户信息
      var url = '/mapi/itask/edit'
      console.log('url', url)
      var that = this
      var param = {}
      param.begin_at = this.formItem.begin_at.getTime() / 1000
      param.end_at = this.formItem.end_at.getTime() / 1000
      if (this.formItem.online === true) {
        param.online = 1
      } else {
        param.online = 0
      }
      param.id = this.formItem.id
      param.keyword = this.formItem.keyword
      param.type = this.formItem.type
      param.region_code = this.selRegion
      const msg = this.$Message.loading({
        content: 'Loading...',
        duration: 0
      })

      this.axios.post(
        url,
        param
      ).then(function (res) {
        setTimeout(msg, 0)
        if (res.data.code === 200) {
          if (res.data.data.id && res.data.data.id > 0) {
            that.formItem.id = res.data.data.id
            that.$Message.info('保存成功')
            that.$router.push({
              path: '/'
            })
          }
        } else {
          console.log('conform error', res)
          // that.$Message.info(res.data.msg)
          that.message = res.data.msg
        }
      }).catch((e) => {
        setTimeout(msg, 0)
        console.log('保存数据失败', e)
        // that.$Message.info('保存获取数据失败')
        that.message = '保存获取数据失败'
      })
    },
    cancel () {
      console.log('cancel')
      this.$router.push({
        path: '/'
      })
    },
    commit_test () {
      // Make a simple request:
      // console.log('Sending ping from the page')
      var that = this
      var url = this.$store.state.baseurl + '/mapi/user/userinfo'
      this.axios.get(
        url,
        {
        }
      ).then(function (res) {
        if (res.data.code === 200) {
          console.log('登录成功', res.data)
          var uinfo = res.data.data
          console.log('userinfo', uinfo)
          helper.putUser(uinfo)
          that.$router.push({
            path: '/'
          })
        } else if (res.data.code === 401) {
          helper.removeLogin()
          helper.removeUser()
        } else if (res.data.code === 403) {
        } else {
          console.log('conform error', res)
        }
      }).catch((e) => {
        console.log('获取数据失败', e)
      })
    }
  }
}
</script>
<style lang="less" scoped>
.field-header {
  margin-bottom: 10px;
  padding: 0;
  border-width: 1px;
  border-style: solid;
  margin: 10px 0 20px;
  border-width: 1px 0 0;
  border-color: #e6e6e6;
  touch-action: pan-y;
  text-align: left;
  .f-title {
    margin-left: 20px;
    padding: 0 10px;
    font-size: 20px;
    font-weight: 300;
  }
}
.sec {
  // font-size: 16px;
  font-weight: 400;
  color: cornflowerblue;
}
.wxts-p {
  text-align: left;
  margin: 0 0 0 78px;
}
@media (max-width: 768px){
  .wxts-p {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/juliang.vue